import { useEffect, useState } from "react";
import {
  ensureFileSession,
  isProtectedFileUrl,
  FileSessionError,
} from "../../../libraries/fileAccess";
import { getCookie, removeCookie } from "../../../utility/cookie";
import { useNavigate } from "react-router-dom";

export default function FileAccessPage() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  useEffect(() => {
    const path = new URLSearchParams(window.location.search).get("path");
    const base = process.env.REACT_APP_API_URL || "";
    if (
      !path ||
      !path.startsWith("/") ||
      path.startsWith("//") ||
      path.includes("\\") ||
      !base
    ) {
      setError("ファイルのURLを確認してください。");
      return;
    }
    const url = new URL(path, new URL(base).origin).href;
    if (!isProtectedFileUrl(url)) {
      setError("ファイルのURLを確認してください。");
      return;
    }
    if (!getCookie("access_token")) {
      navigate("/login", {
        replace: true,
        state: {
          from: { pathname: `/file-access?path=${encodeURIComponent(path)}` },
        },
      });
      return;
    }
    void ensureFileSession(true)
      .then(() => window.location.replace(url))
      .catch((error: unknown) => {
        if (
          error instanceof FileSessionError &&
          error.response.status === 401
        ) {
          removeCookie("access_token");
          localStorage.removeItem("client");
          localStorage.removeItem("uid");
          window.location.replace("/login");
          return;
        }
        setError(
          "ファイルを開けませんでした。再度ログインしてお試しください。",
        );
      });
  }, [navigate]);
  return <p role="status">{error || "ファイルを開いています…"}</p>;
}
